export const initialSearch = (virksomhetsNavn?: string, title?: string) => {
  if (virksomhetsNavn && virksomhetsNavn.length > 0) {
    return virksomhetsNavn
  }
  if (title && !title.includes('*')) {
    return title.substring(0, title.indexOf(' -')).split('|').join('')
  }
}
